module.exports = __webpack_public_path__ + "media/images/from_cover_to_foal-4a72a2d6e5dce8f1f8547dd880254e3d.png";